module.exports = __webpack_public_path__ + "img/sigma-logo.ac67ea76.jpg";